/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-eval */
import * as React from 'react';
import { Page } from '../../cookbook-ui/Page_SC';
import { XIColors, XIGradients, XIColorUsage } from '@inmoment/the-kitchen';
import { Table } from '../../cookbook-ui/custom-components/Table/Table';
import { GradientSwatch } from '../../cookbook-ui/visual-components/GradientSwatch/GradientSwatch';
import { ColorSwatch } from '../../cookbook-ui/visual-components/ColorSwatch/ColorSwatch';
import { CodeBlock } from '../../cookbook-ui/custom-components/CodeBlock/CodeBlock';
import { Copy } from '../../cookbook-ui/custom-components/Copy/Copy';
import { Blank } from '../intro-pages/Home/FAQ_SC';
import { ColorSwatchSmall } from '../../cookbook-ui/visual-components/ColorSwatchSmall/ColorSwatchSmall';

const { admin, orca, grey, green, yellow, red, white, purple, blue, teal, magenta } = XIColors;
export interface Props {}

export const Colors: React.FC<Props> = (props) => {
  React.useEffect(() => {
    const scroll = () => {
      const lastBit = window.location.href.split('/').slice(-1)[0];
      if (lastBit.split('#').length > 1) {
        const element = document.querySelector(`#${lastBit.split('#')[1]}`);
        element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
    window.addEventListener('load', scroll);
    return () => window.removeEventListener('load', scroll);
  }, []);
  let radii = 135;

  function hexToRgb(hex: string) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (result) return `rgb(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)})`;
  }
  const colorMap = [
    {
      name: 'admin',
      description: 'Used as an accent color for Account Admin.',
    },
    {
      name: 'orca',
      description: 'Used primarily for text and as a replacement for black. Also used as accent color for System Admin.',
    },
    {
      name: 'grey',
      description: 'Used for UI lines.',
    },
    {
      name: 'purple',
      description: 'Used as a hit and accent color in the EX Cloud.',
    },
    {
      name: 'blue',
      description: 'Used as a hit and accent color in the CX Cloud.',
    },
    {
      name: 'green',
      description: 'Used to convey success.',
    },
    {
      name: 'teal',
      description: 'Used as a hit and accent color in the MX Cloud.',
    },
    {
      name: 'yellow',
      description: 'Used to convey caution and as a notification color.',
    },
    {
      name: 'red',
      description: 'Used to convey danger, or negative information.',
    },
    {
      name: 'white',
      description: 'Use it when you need it.',
    },
    {
      name: 'silver',
      description: 'Used as a background when white is not appropriate. ',
    },
    {
      name: 'magenta',
      description: 'Used as a hit and accent color in the PX Cloud.',
    },
  ];
  return (
    <Page>
      <p className="kxi-text-xlarge kxi-text-600">Colors</p>
      <br />
      <p>Find hex values, rgba values, and explanations on each color. Click text to copy it to clipboard.</p>
      <hr id="Colors" />
      <br />
      <br />
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(310px, 1fr))',
          gridAutoRows: '1fr',
          gridGap: 24,
        }}
      >
        {colorMap.map((col) => {
          if (col.name === 'silver') {
            return (
              <ColorSwatch
                color={col.name.charAt(0).toUpperCase() + col.name.slice(1)}
                description={col.description}
                primaryHex={XIColorUsage.silver}
                rows={[
                  {
                    hex: XIColorUsage.silver,
                    name: `silver`,
                    rgb: hexToRgb(XIColorUsage.silver),
                    text: 'orca',
                  },
                ]}
              ></ColorSwatch>
            );
          } else {
            return (
              <ColorSwatch
                color={col.name.charAt(0).toUpperCase() + col.name.slice(1)}
                description={col.description}
                primaryHex={eval(`${col.name}.primary`)}
                rows={[
                  {
                    hex: eval(`${col.name}.light[95]`),
                    name: `${col.name}.light[95]`,
                    rgb: hexToRgb(eval(`${col.name}.light[95]`)),
                    text: 'orca',
                  },
                  {
                    hex: eval(`${col.name}.light[90]`),
                    name: `${col.name}.light[90]`,
                    rgb: hexToRgb(eval(`${col.name}.light[90]`)),
                    text: 'orca',
                  },
                  {
                    hex: eval(`${col.name}.light[80]`),
                    name: `${col.name}.light[80]`,
                    rgb: hexToRgb(eval(`${col.name}.light[80]`)),
                    text: 'orca',
                  },
                  {
                    hex: eval(`${col.name}.light[70]`),
                    name: `${col.name}.light[70]`,
                    rgb: hexToRgb(eval(`${col.name}.light[70]`)),
                    text: 'orca',
                  },
                  {
                    hex: eval(`${col.name}.light[60]`),
                    name: `${col.name}.light[60]`,
                    rgb: hexToRgb(eval(`${col.name}.light[60]`)),
                    text: 'orca',
                  },
                  {
                    hex: eval(`${col.name}.light[50]`),
                    name: `${col.name}.light[50]`,
                    rgb: hexToRgb(eval(`${col.name}.light[50]`)),
                    text: col.name === 'white' ? 'orca' : 'white',
                  },
                  {
                    hex: eval(`${col.name}.light[40]`),
                    name: `${col.name}.light[40]`,
                    rgb: hexToRgb(eval(`${col.name}.light[40]`)),
                    text: col.name === 'white' ? 'orca' : 'white',
                  },
                  {
                    hex: eval(`${col.name}.light[30]`),
                    name: `${col.name}.light[30]`,
                    rgb: hexToRgb(eval(`${col.name}.light[30]`)),
                    text: col.name === 'white' ? 'orca' : 'white',
                  },
                  {
                    hex: eval(`${col.name}.light[15]`),
                    name: `${col.name}.light[15]`,
                    rgb: hexToRgb(eval(`${col.name}.light[15]`)),
                    text: col.name === 'white' ? 'orca' : 'white',
                  },
                  {
                    hex: eval(`${col.name}.primary`),
                    name: `${col.name}.primary`,
                    rgb: hexToRgb(eval(`${col.name}.primary`)),
                    text: col.name === 'white' ? 'orca' : 'white',
                  },
                  {
                    hex: eval(`${col.name}.dark[15]`),
                    name: `${col.name}.dark[15]`,
                    rgb: hexToRgb(eval(`${col.name}.dark[15]`)),
                    text: col.name === 'white' ? 'orca' : 'white',
                  },
                  {
                    hex: eval(`${col.name}.dark[40]`),
                    name: `${col.name}.dark[40]`,
                    rgb: hexToRgb(eval(`${col.name}.dark[40]`)),
                    text: col.name === 'white' ? 'orca' : 'white',
                  },
                  {
                    hex: eval(`${col.name}.dark[55]`),
                    name: `${col.name}.dark[55]`,
                    rgb: hexToRgb(eval(`${col.name}.dark[55]`)),
                    text: col.name === 'white' ? 'orca' : 'white',
                  },
                ]}
              ></ColorSwatch>
            );
          }
        })}
      </div>
      <br />
      <hr id="Specific-Colors" />
      <br />
      <br />
      <p className="kxi-text-large kxi-text-600">Specific Colors</p>
      <br />
      <Table
        customColumnWidth={[
          { index: 0, minWidth: 180, maxWidth: '180' },
          { index: 1, minWidth: 260, maxWidth: '260' },
          { index: 2, minWidth: 400, maxWidth: 'unset' },
        ]}
        rows={[
          [
            'Orca',
            <ColorSwatchSmall color={orca.primary} text={'orca.primary'} />,
            'Used primarily for text and as a replacement for black. Also used as accent color for System Admin.',
          ],
          ['Admin Blue', <ColorSwatchSmall color={admin.primary} text={'admin.primary'} />, 'Used as an accent color for Account Admin.'],
          ['CX Blue', <ColorSwatchSmall color={XIColorUsage.cx} text={'XIColorUsage.cx'} />, 'Used as a hit and accent color in the CX Cloud.'],
          ['MX Teal', <ColorSwatchSmall color={XIColorUsage.mx} text={'XIColorUsage.mx'} />, 'Used as a hit and accent color in the MX Cloud.'],
          ['EX Purple', <ColorSwatchSmall color={XIColorUsage.ex} text={'XIColorUsage.ex'} />, 'Used as a hit and accent color in the EX Cloud.'],
          ['PX Magenta', <ColorSwatchSmall color={XIColorUsage.px} text={'XIColorUsage.px'} />, 'Used as a hit and accent color in the PX Cloud.'],
          ['Red', <ColorSwatchSmall color={red.primary} text={'red.primary'} />, 'Used to convey danger, or negative information.'],
          ['Yellow', <ColorSwatchSmall color={yellow.primary} text={'yellow.primary'} />, 'Used to convey caution and as a notification color.'],
          ['Green', <ColorSwatchSmall color={green.primary} text={'green.primary'} />, 'Used to convey success.'],
          ['Grey', <ColorSwatchSmall color={grey.primary} text={'grey.primary'} />, 'Used for UI lines.'],
          [
            'Silver Background',
            <ColorSwatchSmall color={XIColorUsage.silver} text={'XIColorUsage.silver'} />,
            'Used as a background when white is not appropriate.',
          ],
          ['White', <ColorSwatchSmall color={white.primary} text={'white.primary'} />, 'Use it when you need it.'],
        ]}
        columns={['Name', 'Swatch', 'Description']}
      />
      <br />
      <br id="Gradients" />
      <br />
      <p className="kxi-text-large kxi-text-600">Gradients</p>
      <br />
      <p>Gradients add texture and help to make the app feel more alive.</p>
      <br />
      <br />
      <Table
        customColumnWidth={[
          { index: 0, minWidth: 160, maxWidth: '160' },
          { index: 1, minWidth: 160, maxWidth: '160' },
          { index: 2, minWidth: 400, maxWidth: 'unset' },
        ]}
        rows={[
          [
            'cxGradient',
            <GradientSwatch gradient={XIGradients.cxGradient} />,
            <Copy
              textToCopy={`linear-gradient(${radii}deg, ${XIColors.blue.primary} 0%, ${XIColors.orca.primary} 200%)`}
            >{`linear-gradient(${radii}deg, ${XIColors.blue.primary} 0%, ${XIColors.orca.primary} 200%)`}</Copy>,
          ],
          [
            'exGradient',
            <GradientSwatch gradient={XIGradients.exGradient} />,
            <Copy
              textToCopy={`linear-gradient(${radii}deg, ${XIColors.purple.primary} 0%, ${XIColors.orca.primary} 200%)`}
            >{`linear-gradient(${radii}deg, ${XIColors.purple.primary} 0%, ${XIColors.orca.primary} 200%)`}</Copy>,
          ],
          [
            'mxGradient',
            <GradientSwatch gradient={XIGradients.mxGradient} />,
            <Copy
              textToCopy={`linear-gradient(${radii}deg, ${XIColors.teal.primary} 0%, ${XIColors.orca.primary} 200%)`}
            >{`linear-gradient(${radii}deg, ${XIColors.teal.primary} 0%, ${XIColors.orca.primary} 200%)`}</Copy>,
          ],
          [
            'orcaGradient',
            <GradientSwatch gradient={XIGradients.orcaGradient} />,
            <Copy
              textToCopy={`linear-gradient(${radii}deg, ${XIColors.orca.light[15]} 0%, ${XIColors.orca.dark[40]} 200%)`}
            >{`linear-gradient(${radii}deg, ${XIColors.orca.light[15]} 0%, ${XIColors.orca.dark[40]} 200%)`}</Copy>,
          ],
          [
            'adminGradient',
            <GradientSwatch gradient={XIGradients.adminGradient} />,
            <Copy
              textToCopy={`linear-gradient(${radii}deg, ${XIColors.admin.primary} 0%, ${XIColors.orca.primary} 200%)`}
            >{`linear-gradient(${radii}deg, ${XIColors.admin.primary} 0%, ${XIColors.orca.primary} 200%)`}</Copy>,
          ],
        ]}
        columns={['Name', 'Swatch', 'Linear Gradient Value']}
      />
      <br />
      <br id="Accessing-Colors" />
      <p className="kxi-text-large kxi-text-600">Accessing Colors</p>
      <br />
      <p>All of these colors can easily be reference just by knowing the name.</p>
      <br />
      <br />
      <p className="kxi-text-300 kxi-text-normal">XIColors</p>
      <br />
      <CodeBlock
        code={`import { XIColors } from '@inmoment/the-kitchen';

// destructuring optional but is cleaner for multiple colors
const { orca } = XIColors;

const orcaPrimary = orca.primary;
const orcaLight = orca.light[50];
const orcaDark = orca.dark[55];`}
      />
      <br />
      <br />
      <p className="kxi-text-300 kxi-text-normal">XIGradients</p>
      <br />
      <CodeBlock
        code={`import { XIGradients } from '@inmoment/the-kitchen';

// destructuring optional but is cleaner for multiple gradients
const { cxGradient } = XIGradients;`}
      />
      <Blank />
    </Page>
  );
};
